import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { es },
        current: 'es',
    },
    theme: {
        dark: false,
        themes: {
            light: {
                //primary: '#33425B',
                //secondary: '#484CB0',
                //success: '#5BAAEC',
                main: '#1F2937',
                primary: '#4181F2',
                secondary: '#4181F2',
                terciary:'ffbb24',
                success: '#4181F2',
                dark_blue:'#02293e',
                medium_blue:'#4181F2',
                light_blue:'#4181F2',
                custom_yellow:'ffb224',
                custom_orange:'fe7d1e'
                //accent: '#8c9eff',
                //error: '#b71c1c',
            },
            dark: {
                //primary: '#DDDC00',
            }
        },
    }
});